import { apiFGTS } from "../http/httpClient";

interface EditTransactionInput {
  crefazValidation: boolean;
  transactionId?: string;
}

export const updateTransactionCrefaz = async (
  input: EditTransactionInput,
): Promise<any> => {
  const { transactionId, ...formData } = input;
  const response = await apiFGTS
    .put<any>(`/self-hire/transaction/${transactionId}`, formData)
    .catch((error) => {
      throw error.response.data;
    });
  return response.data;
};
